import { TableProps } from "antd/lib/table";
import { TileSparkline } from "components";
import { Table } from "components/base";
import {useCallback, useState, useMemo , useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { Tooltip, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";

import {
  FINANCIALS_WIDGET,
} from "components/tab-content/dashboard-content/__mock__";
import {parseBillingFieldsTable} from "../../utils/parsers/billing-parser";
import {useCookies} from "react-cookie";

interface ComponentProps {
  name: string;
  selectedDate: string;
  organizationId: string;
}

const columns: TableProps<any>["columns"] = [
  { title: "Name", dataIndex: "name" },
  // { title: "Count", dataIndex: "count", align: "center" },
  { title: "Value", dataIndex: "value", align: "right" },
];



export default function FinancialWidget(props: ComponentProps) {
  const [{ meta }] = useCookies();
  const { name, selectedDate,organizationId } = props;


  // let data = FINANCIALS_WIDGET[name];
  let data =  {
      title: "Grand Total",
      value: "PKR 0",
      chart:[],
      footer: "For Month of ",
      due_date_tag: "Due Date: ",
      after_due_date_tag: "Payable after due date: ",
      due_date: "28 August 2025",
      value_after_due_date: "PKR 0",
      month_name: "August 2025",
      table: [
          { key: 0, name: "Subtotal", value: "PKR 4,500" },
          { key: 1, name: "Tax", value: "PKR 9,500" },
           { key: 2, name: "Arrears", value: "PKR 500" },
          { key: 3, name: "Adjustment", value: "PKR 1,000" },

      ],
  }
  const dispatch = useDispatch();

  const {
    bill,
      totalBill
  } = useSelector<AppState, AppState["billing"]>((state) => state.billing);

  const billData = useMemo(
      () => parseBillingFieldsTable(bill),
      [bill]
  );

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    message.success("Copied to clipboard!");
  };
  
  // useEffect(() => {
  //   const user = meta?.user
  //   dispatch(initializeCustomerBilling({organization_id:organizationId, date:selectedDate}));
  // }, [dispatch,totalBill]);
  if (totalBill) {
    data.value = totalBill
  }
  let newDate = new Date()
 console.log("bill data : ", billData);
  if(billData) {
      data.table[0].value =  "PKR " + billData.subTotal 
      data.table[1].value =  "PKR " + billData.tax 
      data.table[2].value =  "PKR " + billData.calcArrears
      data.table[3].value =  "PKR " + billData.adjustment
      data.month_name = billData.monthYear || newDate.toLocaleString('default', { month: 'long' })+", "+ newDate.getFullYear()
      data.due_date = billData.dueDate || "--/--/----"
      data.value_after_due_date = "PKR " + billData.totalWithPanelty
  }else{
    data.table[0].value =  "PKR 0" 
      data.table[1].value =  "PKR 0"  
      data.table[2].value =  "PKR 0"
      data.table[3].value =  "PKR 0"
      data.month_name = ""
      data.due_date =  "--/--/----"
      data.value_after_due_date = "PKR 0"
  }
  return (
    <section className="financial-widget">
      <div className="summary" >
      <p className="title">
          {data.footer} <span className="total-value" style={{float: 'unset',fontSize: "16px"}}>{data.month_name}</span>
        </p>
   <br></br>
        <Table
          customClasses="--simple-table"
          showHeader={false}
          dataSource={data.table}
          columns={columns}
          pagination={false}
          bordered
        />
             {/* <div className="chart-container">
          <div className="chart">
            <TileSparkline className="" data={data.chart} />
          </div>
        </div> */}
       
      </div>
      <div className="detail">
       
          <p className="footer">
          <strong>{data.title}</strong>
        </p>
          <h1 className="value">{data.value}</h1>
          <p className="title">
          {data.due_date_tag} <span className="total-value" style={{float: 'unset',fontWeight: "bold"}}>{data.due_date}</span>
        </p>
          <p className="title">
          {data.after_due_date_tag} <span className="total-value" style={{float: 'unset',fontWeight: "bold"}}>{data.value_after_due_date}</span>
        </p>
        <div style={{ marginTop: "1px" }}>
        <hr
  style={{
    margin: "3px 0",
    border: "0",
    borderTop: "5px solid rgb(83, 82, 82)",
  }}
/>

  <p className="footer">
    <strong>Banking Details</strong>
  </p>

  <p className="title">
    Bank Name:&nbsp;
    <span className="total-value" style={{ fontWeight: "bold" }}>
      Soneri Bank Limited
    </span>
  </p>

  <p className="title">
    Title:&nbsp;
    <span className="total-value" style={{ fontWeight: "bold" }}>
      Electric Energe (Private) Limited
    </span>
  </p>

  {/* ---- ACCOUNT NUMBER ---- */}
  <p className="title" style={{ display: "flex", alignItems: "center" }}>
    Account Number:&nbsp;
    <span className="total-value" style={{ fontWeight: "bold" }}>
      20008074683
    </span>

    <Tooltip title="Copy">
      <CopyOutlined
        onClick={() => copyToClipboard("20008074683")}
        style={{
          marginLeft: 8,
          fontSize: 14,
          cursor: "pointer",
        }}
      />
    </Tooltip>
  </p>

  {/* ---- IBAN ---- */}
  <p className="title" style={{ display: "flex", alignItems: "center" }}>
    IBAN:&nbsp;
    <span className="total-value" style={{ fontWeight: "bold" }}>
      PK97SONE0003520008074683
    </span>

    <Tooltip title="Copy">
      <CopyOutlined
        onClick={() => copyToClipboard("PK97SONE0003520008074683")}
        style={{
          marginLeft: 8,
          fontSize: 14,
          cursor: "pointer",
        }}
      />
    </Tooltip>
  </p>
</div>


      </div>
    </section>
  );
}
